export * from './types';

export const XBUY_COOKIE_TOKEN = 'token';
export const XBUY_COOKIE_DOMAIN = 'domain';
